import { render, staticRenderFns } from "./IdleTimeout.vue?vue&type=template&id=3872cb1e"
import script from "./IdleTimeout.vue?vue&type=script&lang=js"
export * from "./IdleTimeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports